/**
 * Onaylar Servisi
 *
 * İzin, fazla mesai, saha modu, saha aktivitesi ve talep onaylarını tek noktadan
 * listeleme ve karara bağlama (Yönetici / Admin için). Singleton pattern.
 */

import apiService from '../api/api.service';
import {
  ApprovalCountsResponse,
  ApprovalDecisionDTO,
  ApprovalDecisionResponse,
  ApprovalPendingResponse,
  ApprovalType,
} from '../../types/approvals.types';

class ApprovalsService {
  private static instance: ApprovalsService;

  private constructor() {}

  public static getInstance(): ApprovalsService {
    if (!ApprovalsService.instance) {
      ApprovalsService.instance = new ApprovalsService();
    }
    return ApprovalsService.instance;
  }

  /**
   * Onay bekleyen tüm talepleri getirir (opsiyonel tip filtresi ile)
   */
  public async getPendingApprovals(types?: ApprovalType[]): Promise<ApprovalPendingResponse> {
    return apiService.get<ApprovalPendingResponse>('/approvals/pending', {
      params: types && types.length > 0 ? { types: types.join(',') } : undefined,
    });
  }

  /**
   * Tip bazında bekleyen onay sayılarını getirir
   */
  public async getApprovalCounts(): Promise<ApprovalCountsResponse> {
    return apiService.get<ApprovalCountsResponse>('/approvals/counts');
  }

  /**
   * Talebi onayla veya reddet
   */
  public async decide(type: ApprovalType, id: number, data: ApprovalDecisionDTO): Promise<ApprovalDecisionResponse> {
    return apiService.put<ApprovalDecisionResponse>(`/approvals/${type}/${id}`, data);
  }
}

export default ApprovalsService.getInstance();
